export default "__VITE_ASSET__DsjqbAG7__"